// src\components\Payroll\ProcessPartialSalaryFld\shared\EditEligibilityForm.jsx
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

/**
 * EditEligibilityForm
 *
 * Props:
 *   isOpen      — boolean
 *   onClose     — () => void
 *   employee    — the selected processed row object
 *   onSubmit    — (employeeRow, isEligible, onClose) => void
 */
// ADDED
export const EditEligibilityForm = ({ isOpen, onClose, employee, onSubmit }) => {
  const [isEligible, setIsEligible] = useState(false);

  // ADDED: pre-populate checkbox from employee row's current isEligible value
  useEffect(() => {
    if (isOpen && employee) {
      setIsEligible(employee.isEligibleRaw ?? false);
    }
    if (!isOpen) {
      setIsEligible(false);
    }
  }, [isOpen, employee]);

  const submit = () => {
    onSubmit(employee, isEligible, onClose);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay open">
      <div className="modal">
        <div className="popUp-header row">
          <div className="popUp-title">
            <h3 style={{ color: "#668fca" }}>Edit Eligibility</h3>
          </div>
          <div className="popUp-close"><CloseIcon onClick={onClose} /></div>
        </div>

        <div className="popUp-body column" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "20px 40px" }}>

          {/* Employee name display */}
          {employee && (
            <div style={{ marginBottom: "16px", fontSize: "14px", color: "rgb(104,104,104)" }}>
              <b>Employee:</b> {employee.employeeFullName ?? "—"}
            </div>
          )}

          {/* isEligible checkbox */}
          <div className="popUp-item info-item row" style={{ alignItems: "center" }}>
            <div className="info-item-input">
              <input
                type="checkbox"
                id="isEligible-checkbox"
                className="checkbox"
                checked={isEligible}
                onChange={(e) => setIsEligible(e.target.checked)}
              />
            </div>
            <div className="info-item-label" style={{ paddingLeft: "10px" }}>
              Is Eligible
            </div>
          </div>

        </div>

        <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
          <button className="save row" onClick={submit} style={{ marginRight: "5px" }}>SAVE</button>
          <button className="cancel row" onClick={onClose}>CANCEL</button>
        </div>
      </div>
    </div>
  );
};